export const createRule = "jRa";
export default {createRule};